export const UserRoleEndpoints = {
  edit: (id: string) => `/preferences/user-role/edit/${id}`,
  list: '/preferences/user-role/list',
  assignable: '/preferences/user-role/list/assignable',
  export: '/preferences/user-role/export',
  add: '/preferences/user-role/add',
  details: (id: string) => `/preferences/user-role/${id}`,
  delete: (id: string) => `/preferences/user-role/del/${id}`,
  deleteBatch: '/preferences/user-role/del/batch',
};
